import { render, staticRenderFns } from "./TermOfFurusato.vue?vue&type=template&id=657443ff&"
import script from "./TermOfFurusato.vue?vue&type=script&lang=js&"
export * from "./TermOfFurusato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports